import React, { useRef, useState } from "react";
import { useEffect } from "react";
import {
  BsInstagram,
  BsFacebook,
  BsTwitter,
  BsYoutube,
  BsPlusCircleFill,
} from "react-icons/bs";
import { useNavigate, useParams } from "react-router";
import AddLink from "../common/AddLink";
import { useForm } from "react-hook-form";
import { hash } from "bcryptjs";
import classes from "./UserForm.module.css";
import Close from "../icons/Close";

const initialUserInfo = {
  name: "",
  email: "",
  username: "",
  password: "",
  bio: "",
  preferredUrlType: 1,
  nsfwStatus: "",
  seoTitle: "",
  seoDescription: "",
  analyticsCode: "",
  creditVlaue: "",
  socialUrlType: 1,
};

let editUserDetails = {};

const UserForm = (props) => {
  const { title, addUser } = props;
  const [activeUser, setActiveUser] = useState(1);
  const [addLinks, setAddLinks] = useState([
    { title: "", link: "", linkType: 1, _id: null, order: 1 },
  ]);
  const [userInfo, setUserInfo] = useState(initialUserInfo);

  const [messageDiv, setMessageDiv] = useState(false);
  const [userMessage, setUserMessage] = useState({ type: "", message: "" });
  const [selectedImage, setSelectedImage] = useState({
    link: "",
    blob: "",
    details: null,
  });

  const [nsfwStatusValue, setNsfwStatusValue] = useState(false);
  const [preferredUrlLink, setPreferredUrlLink] = useState(1);
  const [creditValue, setCreditValue] = useState(false);
  const [socialUrlLink, setSocialUrlLink] = useState(1);
  const [userProfile, setUserProfile] = useState(null);
  const [editPreview, setEditPreview] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    clearErrors,
  } = useForm();

  const changeProfileImage = (e) => {
    const uploadFileDetail = e.target.files[0];
    if (
      uploadFileDetail &&
      !["image/jpeg", "image/jpg", "image/png"].includes(uploadFileDetail?.type)
    ) {
      setError("profile_image", {
        message: "Please enter only JPG/JPEG and PNG images.",
        type: true,
      });
      return;
    } else {
      clearErrors("profile_image");
    }
    if (uploadFileDetail && uploadFileDetail?.size > 2000000) {
      setError("profile_image", {
        message: "Please upload image less then 2 MB.",
        type: true,
      });
      return;
    } else {
      clearErrors("profile_image");
    }
    setUserProfile(e.target.files[0]);
    let fileToUpload = e.target.files.item(0);
    let reader = new FileReader();
    reader.onload = (event) => {
      setSelectedImage({
        link: URL.createObjectURL(uploadFileDetail),
        blob: event.target.result,
        details: {
          type: uploadFileDetail.type,
          name: uploadFileDetail.name,
          size: uploadFileDetail.size,
        },
      });
    };
    reader.readAsDataURL(fileToUpload);
  };

  const imgSvgHandler = () => {
    setSelectedImage({
      link: "",
      blob: "",
      details: null,
    });
    setEditPreview(null);
    setUserProfile(null);
  };

  const { userId } = useParams();
  const nav = useNavigate();

  /* social */
  const instagram = useRef("");
  const facebook = useRef("");
  const twitter = useRef("");
  const youtube = useRef("");

  const statusChangeHandler = (e) => {
    setActiveUser(+e.target.value);
  };

  const preferredLinkHandleChange = (value) => {
    setPreferredUrlLink(value);
  };

  const socialLinkHandleChange = (value) => {
    setSocialUrlLink(value);
  };

  const userInfoHandleChange = (e) => {
    const { name, value } = e.target;
    setUserInfo((preVal) => ({ ...preVal, [name]: value }));
  };

  const formSubmitHandler = async (e) => {
    // e.preventDefault();

    let userDetail = {
      name: userInfo.name,
      email: userInfo.email,
      username: userInfo.username,
      password: userInfo.password,
      bio: userInfo.bio,
      status: activeUser,
      preferredUrlType: preferredUrlLink,
      nsfwStatus: nsfwStatusValue,
      seoTitle: userInfo.seoTitle,
      seoDescription: userInfo.seoDescription,
      analyticsCode: userInfo.analyticsCode,
      creditValue: creditValue,
      socialUrlType: socialUrlLink,
    };

    if (addUser) {
      const socialArray = [
        {
          title: "Instagram",
          linkType: 2,
          subType: 1,
          link: instagram.current.value,
          order: 1,
          placeholder: "Instagram username",
          linkUsername: true,
          mainLink: "https://instagram.com/",
        },
        {
          title: "Facebook",
          linkType: 2,
          subType: 2,
          link: facebook.current.value,
          order: 2,
          linkUsername: false,
          placeholder: "https://facebook.com/pageurl",
        },
        {
          title: "Twitter",
          linkType: 2,
          subType: 3,
          link: twitter.current.value,
          order: 3,
          placeholder: "Twitter username",
          linkUsername: true,
          mainLink: "https://twitter.com/",
        },
        {
          title: "Youtube",
          linkType: 2,
          subType: 4,
          link: youtube.current.value,
          order: 4,
          placeholder: "https://youtube.com/channel/channelurl",
          linkUsername: false,
        },
      ];
      addLinks.push(...socialArray);

      userDetail.password = await hash(userInfo.password, 12);
      const formData = new FormData();
      formData.append("profile", userProfile);
      formData.append("userDetails", JSON.stringify(userDetail));
      formData.append("links", JSON.stringify(addLinks));

      const response = await fetch(`${process.env.REACT_APP_API_URL}add-user`, {
        method: "POST",
        body: formData,
      });

      const resData = await response.json();
      if (response && response.status === 200) {
        setUserMessage({ type: "success", message: resData.message });
      } else {
        setUserMessage({ type: "danger", message: resData.message });
      }
      setMessageDiv(true);
    }

    if (!addUser) {
      userDetail["userId"] = userId;
      userDetail["profile"] = editUserDetails.userDetail.profile;
      if (userInfo.password) {
        userDetail.password = await hash(userInfo.password, 12);
      }

      const socialUrls = editUserDetails.links.filter((ele) => {
        return ele.linkType === 2;
      });

      socialUrls.forEach((val) => {
        if (val.subType === 1) {
          val.link = instagram.current.value;
        }
        if (val.subType === 2) {
          val.link = facebook.current.value;
        }
        if (val.subType === 3) {
          val.link = twitter.current.value;
        }
        if (val.subType === 4) {
          val.link = youtube.current.value;
        }
      });

      let allLinks = [...addLinks];
      allLinks.push(...socialUrls);

      const formData = new FormData();
      formData.append("profile", userProfile);
      formData.append("userDetails", JSON.stringify(userDetail));
      formData.append("links", JSON.stringify(allLinks));

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}edit-user`,
        {
          method: "PUT",
          body: formData,
        }
      );
      const resData = await response.json();
      if (response && response.status === 200) {
        setUserMessage({ type: "success", message: resData.message });
      } else {
        setUserMessage({ type: "danger", message: resData.message });
      }
      setMessageDiv(true);
    }
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    (async () => {
      if (!addUser && userId) {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}user/${userId}`
        );

        const resData = await response.json();
        setEditPreview(resData.data.userDetail.profile);
        editUserDetails = resData.data;
        if (resData.data.userDetail) {
          resData.data.links.forEach((val) => {
            if (val.linkType === 2 && val.subType === 1) {
              instagram.current.value = val.link;
            }
            if (val.linkType === 2 && val.subType === 2) {
              facebook.current.value = val.link;
            }
            if (val.linkType === 2 && val.subType === 3) {
              twitter.current.value = val.link;
            }
            if (val.linkType === 2 && val.subType === 4) {
              youtube.current.value = val.link;
            }
          });
          setUserInfo({
            name: resData.data.userDetail.name,
            email: resData.data.userDetail.email,
            username: resData.data.userDetail.username,
            bio: resData.data.userDetail.bio,
            preferredUrlType: resData.data.userDetail.preferredUrlType,
            nsfwStatus: resData.data.userDetail.nsfwStatus,
            creditValue: resData.data.userDetail.creditValue,
            socialUrlType: resData.data.userDetail.socialUrlType,
            seoTitle: resData.data.userDetail.seoTitle,
            seoDescription: resData.data.userDetail.seoDescription,
            analyticsCode: resData.data.userDetail.analyticsCode,
          });
          setPreferredUrlLink(
            parseInt(resData.data.userDetail.preferredUrlType)
          );
          setNsfwStatusValue(resData.data.userDetail.nsfwStatus);
          setCreditValue(resData.data.userDetail.creditValue);
          setSocialUrlLink(resData.data.userDetail.socialUrlType);
          setActiveUser(resData.data.userDetail.status);
          setAddLinks(
            resData.data.links.filter((val) => {
              return val.linkType === 1;
            })
          );
          if (resData.data.links.length === 0) {
            setAddLinks([
              { title: "", link: "", linkType: 1, _id: null, order: 1 },
            ]);
          }
        }
      }
    })();
  }, [addUser, userId]);

  if (messageDiv) {
    setTimeout(() => {
      setMessageDiv(false);
      nav("/admin/users");
      return;
    }, 2000);
  }

  const addLinkListHandler = () => {
    const obj = {
      title: "",
      link: "",
      linkType: 1,
      _id: null,
    };
    obj["order"] = addLinks[addLinks.length - 1].order + 1;
    setAddLinks([...addLinks, obj]);
  };

  const addLinkHandler = (e, index) => {
    let data = [...addLinks];
    data[index][e.target.name] = e.target.value;
    setAddLinks(data);
  };

  return (
    <React.Fragment>
      <div className="content-body">
        <div className="container-fluid">
          <div className="d-flex mb-4">
            <h4 className="fs-20 font-w600 mb-0 me-auto">{title}</h4>
            <h4 className="mx-3">Status:</h4>
            <div className="form-check form-check-inline">
              <input
                type="radio"
                className="form-check-input"
                checked={activeUser === 1}
                name="optradio"
                value={1}
                onChange={statusChangeHandler}
              />
              <label className="form-check-label font-w600" htmlFor="status">
                Active
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                type="radio"
                className="form-check-input"
                name="optradio"
                value={0}
                checked={activeUser === 0}
                onChange={statusChangeHandler}
              />
              <label className="form-check-label font-w600" htmlFor="status">
                Inactive
              </label>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-12">
              <form onSubmit={handleSubmit(formSubmitHandler)}>
                <div className="card">
                  <div className="card-body">
                    {messageDiv && (
                      <div
                        className={`alert alert-${userMessage.type} alert-dismissible fade show`}
                      >
                        <svg
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                          stroke="currentColor"
                          strokeWidth="2"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="me-2"
                        >
                          <polyline points="9 11 12 14 22 4"></polyline>
                          <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                        </svg>
                        {userMessage.message}
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="alert"
                          aria-label="btn-close"
                        ></button>
                      </div>
                    )}
                    <div className="row">
                      <div className="col-xl-6 col-md-6 mb-4">
                        <label className="form-label font-w600">
                          Name<span className="text-danger scale5 ms-2">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control solid"
                          placeholder="Name"
                          aria-label="name"
                          name="name"
                          defaultValue={userInfo.name}
                          {...register("name", {
                            required: addUser ? "Name is Required" : false,
                          })}
                          onChange={userInfoHandleChange}
                        />
                        {errors.name && (
                          <div className="text-danger">
                            {errors.name.message}
                          </div>
                        )}
                      </div>
                      <div className="col-xl-6 col-md-6 mb-4">
                        <label className="form-label font-w600">
                          Email
                          <span className="text-danger scale5 ms-2">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control solid"
                          placeholder="Email"
                          aria-label="email"
                          name="email"
                          defaultValue={userInfo.email}
                          {...register("email", {
                            required: addUser ? "Email is required" : false,
                            pattern: {
                              value:
                                /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z]{2,4}$/i,
                              message: "Enter a valid e-mail address",
                            },
                          })}
                          onChange={userInfoHandleChange}
                        />
                        {errors.email && (
                          <div className="text-danger">
                            {errors.email.message}
                          </div>
                        )}
                      </div>
                      <div className="col-xl-6 col-md-6 mb-4">
                        <label className="form-label font-w600">
                          Username
                          <span className="text-danger scale5 ms-2">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control solid"
                          placeholder="Username"
                          aria-label="username"
                          name="username"
                          defaultValue={userInfo.username}
                          {...register("username", {
                            required: addUser ? "Username is required" : false,
                            pattern: {
                              value: /^(?!.*\.\.)(?!.*\.$)[^\W][\w.]{2,29}$/,
                              message: "Enter a valid username",
                            },
                          })}
                          onChange={userInfoHandleChange}
                        />
                        {errors.username && (
                          <div className="text-danger">
                            {errors.username.message}
                          </div>
                        )}
                      </div>
                      <div className="col-xl-6 col-md-6 mb-4">
                        <label className="form-label font-w600">
                          Password
                          <span className="text-danger scale5 ms-2">*</span>
                        </label>
                        <input
                          type="password"
                          className="form-control solid"
                          placeholder="Password"
                          aria-label="password"
                          name="password"
                          defaultValue={userInfo.password}
                          {...register("password", {
                            required: addUser ? "Password is Required" : false,
                            minLength: {
                              value: 8,
                              message:
                                "Password must be more than 8 characters",
                            },
                          })}
                          onChange={userInfoHandleChange}
                        />
                        {errors.password && (
                          <div className="text-danger">
                            {errors.password.message}
                          </div>
                        )}
                      </div>
                      <div className="col-xl-6  col-md-6 mb-4">
                        <label className="form-label font-w600">
                          User Profile
                          <span className="text-danger scale5 ms-2">*</span>
                        </label>
                        {editPreview && (
                          <div className={classes.adminProfileImg}>
                            <img
                              src={
                                process.env.REACT_APP_IMAGE_URL +
                                "profile-images/" +
                                editPreview
                              }
                              alt="User"
                            />
                            <Close imgSvgHandler={imgSvgHandler} />
                          </div>
                        )}
                        {selectedImage && selectedImage.link !== "" && (
                          <div className={classes.adminProfileImg}>
                            <img src={selectedImage.link} alt="User" />
                            <Close imgSvgHandler={imgSvgHandler} />
                          </div>
                        )}
                        {!editPreview &&
                          selectedImage &&
                          selectedImage.link === "" && (
                            <div className="form-file">
                              <input
                                {...register("profile_image", {
                                  validate: {
                                    checkFile: (files) =>
                                      files.length !== 0 ||
                                      "Please upload a user Profile image.",
                                    acceptedFormats: (files) =>
                                      [
                                        "image/jpeg",
                                        "image/jpg",
                                        "image/png",
                                      ].includes(files[0]?.type) ||
                                      "Please enter only JPG/JPEG and PNG images.",
                                    fileSize: (files) =>
                                      files[0]?.size < 2000000 ||
                                      "Please upload image less then 2 MB.",
                                  },
                                })}
                                id="select-image"
                                className="form-file-input form-control solid"
                                type="file"
                                accept="image/*"
                                onChange={(event) => {
                                  changeProfileImage(event);
                                }}
                              />
                              {errors.profile_image && (
                                <span className="text-danger">
                                  {errors.profile_image.message}
                                </span>
                              )}
                            </div>
                          )}
                      </div>
                      <div className="col-xl-6  col-md-6 mb-4">
                        <label className="form-label font-w600">
                          Bio<span className="text-danger scale5 ms-2">*</span>
                        </label>
                        <textarea
                          className="form-control solid"
                          placeholder="Bio"
                          name="bio"
                          defaultValue={userInfo.bio}
                          {...register("bio", {
                            required: addUser ? "Bio is Required" : false,
                          })}
                          onChange={userInfoHandleChange}
                        ></textarea>
                        {errors.bio && (
                          <div className="text-danger">
                            {errors.bio.message}
                          </div>
                        )}
                      </div>

                      <div className="col-xl-6 col-md-6 mb-4">
                        <h3>Preferred Link</h3>
                        <div className="mb-3">
                          This is an aesthetic choice. Both links are usable.
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input"
                            id="bio.link1"
                            name="preferredLink"
                            checked={preferredUrlLink === 1}
                            defaultValue={userInfo.username}
                            onChange={() => preferredLinkHandleChange(1)}
                            autoComplete="off"
                          />
                          <label
                            className="form-check-label font-w600"
                            htmlFor="bio.link1"
                          >
                            {process.env.REACT_APP_MAIN_DOMAIN}/
                            {userInfo.username
                              ? userInfo.username
                              : "your_username"}
                          </label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input solid"
                            id="bio.link2"
                            name="preferredLink"
                            checked={preferredUrlLink === 2}
                            defaultValue={userInfo.username}
                            onChange={() => preferredLinkHandleChange(2)}
                            autoComplete="off"
                          />
                          <label
                            className="form-check-label font-w600"
                            htmlFor="bio.link2"
                          >
                            {userInfo.username
                              ? userInfo.username
                              : "your_username"}
                            .{process.env.REACT_APP_MAIN_DOMAIN}
                          </label>
                        </div>

                        {/* <div className="form-check form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input"
                            id="bio.link3"
                            name="preferredLink"
                            checked={preferredUrlLink === 3}
                            defaultValue="custom domain"
                            onChange={() => preferredLinkHandleChange(3)}
                            autoComplete="off"
                          />
                          <label
                            className="form-check-label font-w600"
                            htmlFor="bio.link3"
                          >
                            custom domain
                          </label>
                        </div> */}
                      </div>

                      <div className="col-xl-6 col-md-6 mb-4">
                        <div className="main-heading d-flex justify-content-between">
                          <h3>NSFW Warning:</h3>
                          <div className="form-check form-switch mb-3">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="flexSwitchCheckDefault"
                              checked={nsfwStatusValue}
                              onChange={(e) => {
                                setNsfwStatusValue((prev) => !prev);
                              }}
                            />
                          </div>
                        </div>
                        <div>Show a warning before displaying your page.</div>
                      </div>

                      <div className="col-xl-6 col-md-6 mb-4">
                        <h3>Position to display socials</h3>
                        <div className="form-check form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input"
                            id="socialLink1"
                            name="socialLink"
                            checked={socialUrlLink === 1}
                            defaultValue="top"
                            onChange={() => socialLinkHandleChange(1)}
                            autoComplete="off"
                          />
                          <label
                            className="form-check-label font-w600"
                            htmlFor="socialLink1"
                          >
                            Top
                          </label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input solid"
                            id="socialLink2"
                            name="socialLink"
                            checked={socialUrlLink === 2}
                            defaultValue="bottom"
                            onChange={() => socialLinkHandleChange(2)}
                            autoComplete="off"
                          />
                          <label
                            className="form-check-label font-w600"
                            htmlFor="socialLink2"
                          >
                            Bottom
                          </label>
                        </div>
                      </div>

                      <div className="col-xl-6 col-md-6 mb-4">
                        <div className="main-heading d-flex justify-content-between">
                          <h3>Show Credit:</h3>
                          <div className="form-check form-switch mb-3">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="flexSwitchCheckCredit"
                              checked={creditValue}
                              onChange={() => {
                                setCreditValue((prev) => !prev);
                              }}
                            />
                          </div>
                        </div>
                        <div>
                          We appreciate you showing our logo credit in the
                          footer, but feel free to hide it.
                        </div>
                      </div>

                      <div className="col-xl-12 col-md-12 mb-4">
                        <h3>SEO :</h3>
                        <div className="main-title mb-3">
                          choose the title and description to appear on search
                          engines and social posts.
                        </div>
                        <div className="row mb-1">
                          <div className="col-xl-6 col-md-6">
                            <label
                              className="form-label font-w600"
                              htmlFor="seo-title"
                            >
                              Title :
                            </label>
                            <div className="input-group">
                              <input
                                type="text"
                                id="seo-title"
                                name="seoTitle"
                                className="form-control solid"
                                placeholder="Title"
                                autoComplete="off"
                                defaultValue={userInfo.seoTitle}
                                onChange={userInfoHandleChange}
                              />
                            </div>
                          </div>

                          <div className="col-xl-6 col-md-6">
                            <label
                              className="form-label font-w600"
                              htmlFor="seo-description"
                            >
                              Description :
                            </label>
                            <div className="input-group">
                              <input
                                type="text"
                                id="seo-description"
                                name="seoDescription"
                                className="form-control solid"
                                placeholder="Description (max 160 chars)"
                                autoComplete="off"
                                defaultValue={userInfo.seoDescription}
                                onChange={userInfoHandleChange}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-6 col-md-6 mb-4">
                        <label className="form-label font-w600">
                          Google Analytics
                        </label>
                        <input
                          type="text"
                          className="form-control solid"
                          placeholder="G-xxxxxxxxxx"
                          aria-label="analytics"
                          name="analyticsCode"
                          autoComplete="off"
                          defaultValue={userInfo.analyticsCode}
                          onChange={userInfoHandleChange}
                        />
                      </div>

                      <hr />
                      <div className="col-xl-12  col-md-12 mb-4 add-user-link">
                        <h2>
                          Links
                          <span>
                            <BsPlusCircleFill onClick={addLinkListHandler} />
                          </span>
                        </h2>
                      </div>
                      {addLinks.map((val, index) => {
                        return (
                          <AddLink
                            key={index}
                            val={val}
                            index={index}
                            onAddLinkHandler={addLinkHandler}
                          />
                        );
                      })}
                      <hr />
                      <div className="col-xl-12  col-md-12 mb-4">
                        <h2>Socials</h2>
                      </div>
                      <div className="col-xl-6  col-md-6 mb-4">
                        <label className="form-label font-w600">
                          Instagram
                        </label>
                        <div className="input-group">
                          <div className="input-group-text">
                            <BsInstagram />
                          </div>
                          <input
                            type="text"
                            className="form-control solid"
                            placeholder="Instagram username"
                            aria-label="name"
                            name="instagram"
                            ref={instagram}
                          />
                        </div>
                      </div>
                      <div className="col-xl-6  col-md-6 mb-4">
                        <label className="form-label font-w600">Facebook</label>
                        <div className="input-group">
                          <div className="input-group-text">
                            <BsFacebook />
                          </div>
                          <input
                            type="text"
                            className="form-control solid"
                            placeholder="https://facebook.com/pageurl"
                            aria-label="name"
                            name="facebook"
                            ref={facebook}
                          />
                        </div>
                      </div>
                      <div className="col-xl-6  col-md-6 mb-4">
                        <label className="form-label font-w600">Twitter</label>
                        <div className="input-group">
                          <div className="input-group-text">
                            <BsTwitter />
                          </div>
                          <input
                            type="text"
                            className="form-control solid"
                            placeholder="Twitter username"
                            aria-label="name"
                            name="twitter"
                            ref={twitter}
                          />
                        </div>
                      </div>
                      <div className="col-xl-6  col-md-6 mb-4">
                        <label className="form-label font-w600">YouTube</label>
                        <div className="input-group">
                          <div className="input-group-text">
                            <BsYoutube />
                          </div>
                          <input
                            type="text"
                            className="form-control solid"
                            placeholder="https://youtube.com/channel/channelurl"
                            aria-label="name"
                            name="youtube"
                            ref={youtube}
                          />
                        </div>
                      </div>
                      <hr />
                    </div>
                  </div>
                  <div className="card-footer text-end">
                    <div>
                      <button className="btn btn-secondary" type="submit">
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default UserForm;
